// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"2cdae992","908":"2094ecdd"}[chunkId] + ".chunk.js";
};